import React from 'react';
import { ResetPassContainer } from 'features/RegistrationContainer';

const ResetPassword = (props) => {
  return (
    <div>
      <ResetPassContainer {...props} />
    </div>
  );
};

export default ResetPassword;
